import {defaultFormat} from "moment";

export default class Tzdb {

  public static readonly tzList =
    [{id: "Africa/Abidjan", displayName: "Greenwich Mean Time"},
      {id: "Africa/Accra", displayName: "Ghana Mean Time"},
      {id: "Africa/Addis_Ababa", displayName: "Eastern African Time"},
      {id: "Africa/Algiers", displayName: "Central European Time"},
      {id: "Africa/Asmara", displayName: "Eastern African Time"},
      {id: "Africa/Asmera", displayName: "Eastern African Time"},
      {id: "Africa/Bamako", displayName: "Greenwich Mean Time"},
      {id: "Africa/Bangui", displayName: "Western African Time"},
      {id: "Africa/Banjul", displayName: "Greenwich Mean Time"},
      {id: "Africa/Bissau", displayName: "Greenwich Mean Time"},
      {id: "Africa/Blantyre", displayName: "Central African Time"},
      {id: "Africa/Brazzaville", displayName: "Western African Time"},
      {id: "Africa/Bujumbura", displayName: "Central African Time"},
      {id: "Africa/Cairo", displayName: "Eastern European Time"},
      {id: "Africa/Casablanca", displayName: "Western European Time"},
      {id: "Africa/Ceuta", displayName: "Central European Time"},
      {id: "Africa/Conakry", displayName: "Greenwich Mean Time"},
      {id: "Africa/Dakar", displayName: "Greenwich Mean Time"},
      {id: "Africa/Dar_es_Salaam", displayName: "Eastern African Time"},
      {id: "Africa/Djibouti", displayName: "Eastern African Time"},
      {id: "Africa/Douala", displayName: "Western African Time"},
      {id: "Africa/El_Aaiun", displayName: "Western European Time"},
      {id: "Africa/Freetown", displayName: "Greenwich Mean Time"},
      {id: "Africa/Gaborone", displayName: "Central African Time"},
      {id: "Africa/Harare", displayName: "Central African Time"},
      {id: "Africa/Johannesburg", displayName: "South Africa Standard Time"},
      {id: "Africa/Juba", displayName: "Eastern African Time"},
      {id: "Africa/Kampala", displayName: "Eastern African Time"},
      {id: "Africa/Khartoum", displayName: "Central African Time"},
      {id: "Africa/Kigali", displayName: "Central African Time"},
      {id: "Africa/Kinshasa", displayName: "Western African Time"},
      {id: "Africa/Lagos", displayName: "Western African Time"},
      {id: "Africa/Libreville", displayName: "Western African Time"},
      {id: "Africa/Lome", displayName: "Greenwich Mean Time"},
      {id: "Africa/Luanda", displayName: "Western African Time"},
      {id: "Africa/Lubumbashi", displayName: "Central African Time"},
      {id: "Africa/Lusaka", displayName: "Central African Time"},
      {id: "Africa/Malabo", displayName: "Western African Time"},
      {id: "Africa/Maputo", displayName: "Central African Time"},
      {id: "Africa/Maseru", displayName: "South Africa Standard Time"},
      {id: "Africa/Mbabane", displayName: "South Africa Standard Time"},
      {id: "Africa/Mogadishu", displayName: "Eastern African Time"},
      {id: "Africa/Monrovia", displayName: "Greenwich Mean Time"},
      {id: "Africa/Nairobi", displayName: "Eastern African Time"},
      {id: "Africa/Ndjamena", displayName: "Western African Time"},
      {id: "Africa/Niamey", displayName: "Western African Time"},
      {id: "Africa/Nouakchott", displayName: "Greenwich Mean Time"},
      {id: "Africa/Ouagadougou", displayName: "Greenwich Mean Time"},
      {id: "Africa/Porto-Novo", displayName: "Western African Time"},
      {id: "Africa/Sao_Tome", displayName: "Western African Time"},
      {id: "Africa/Timbuktu", displayName: "Greenwich Mean Time"},
      {id: "Africa/Tripoli", displayName: "Eastern European Time"},
      {id: "Africa/Tunis", displayName: "Central European Time"},
      {id: "Africa/Windhoek", displayName: "Central African Time"},
      {id: "America/Adak", displayName: "Hawaii Standard Time"},
      {id: "America/Anchorage", displayName: "Alaska Standard Time"},
      {id: "America/Anguilla", displayName: "Atlantic Standard Time"},
      {id: "America/Antigua", displayName: "Atlantic Standard Time"},
      {id: "America/Araguaina", displayName: "Brasilia Time"},
      {id: "America/Argentina/Buenos_Aires", displayName: "Argentine Time"},
      {id: "America/Argentina/Catamarca", displayName: "Argentine Time"},
      {id: "America/Argentina/ComodRivadavia", displayName: "Argentine Time"},
      {id: "America/Argentina/Cordoba", displayName: "Argentine Time"},
      {id: "America/Argentina/Jujuy", displayName: "Argentine Time"},
      {id: "America/Argentina/La_Rioja", displayName: "Argentine Time"},
      {id: "America/Argentina/Mendoza", displayName: "Argentine Time"},
      {id: "America/Argentina/Rio_Gallegos", displayName: "Argentine Time"},
      {id: "America/Argentina/Salta", displayName: "Argentine Time"},
      {id: "America/Argentina/San_Juan", displayName: "Argentine Time"},
      {id: "America/Argentina/San_Luis", displayName: "Argentine Time"},
      {id: "America/Argentina/Tucuman", displayName: "Argentine Time"},
      {id: "America/Argentina/Ushuaia", displayName: "Argentine Time"},
      {id: "America/Aruba", displayName: "Atlantic Standard Time"},
      {id: "America/Asuncion", displayName: "Paraguay Time"},
      {id: "America/Atikokan", displayName: "Eastern Standard Time"},
      {id: "America/Atka", displayName: "Hawaii Standard Time"},
      {id: "America/Bahia", displayName: "Brasilia Time"},
      {id: "America/Bahia_Banderas", displayName: "Central Standard Time"},
      {id: "America/Barbados", displayName: "Atlantic Standard Time"},
      {id: "America/Belem", displayName: "Brasilia Time"},
      {id: "America/Belize", displayName: "Central Standard Time"},
      {id: "America/Blanc-Sablon", displayName: "Atlantic Standard Time"},
      {id: "America/Boa_Vista", displayName: "Amazon Time"},
      {id: "America/Bogota", displayName: "Colombia Time"},
      {id: "America/Boise", displayName: "Mountain Standard Time"},
      {id: "America/Buenos_Aires", displayName: "Argentine Time"},
      {id: "America/Cambridge_Bay", displayName: "Mountain Standard Time"},
      {id: "America/Campo_Grande", displayName: "Amazon Time"},
      {id: "America/Cancun", displayName: "Eastern Standard Time"},
      {id: "America/Caracas", displayName: "Venezuela Time"},
      {id: "America/Catamarca", displayName: "Argentine Time"},
      {id: "America/Cayenne", displayName: "French Guiana Time"},
      {id: "America/Cayman", displayName: "Eastern Standard Time"},
      {id: "America/Chicago", displayName: "Central Standard Time"},
      {id: "America/Chihuahua", displayName: "Mountain Standard Time"},
      {id: "America/Coral_Harbour", displayName: "Eastern Standard Time"},
      {id: "America/Cordoba", displayName: "Argentine Time"},
      {id: "America/Costa_Rica", displayName: "Central Standard Time"},
      {id: "America/Creston", displayName: "Mountain Standard Time"},
      {id: "America/Cuiaba", displayName: "Amazon Time"},
      {id: "America/Curacao", displayName: "Atlantic Standard Time"},
      {id: "America/Danmarkshavn", displayName: "Greenwich Mean Time"},
      {id: "America/Dawson", displayName: "Pacific Standard Time"},
      {id: "America/Dawson_Creek", displayName: "Mountain Standard Time"},
      {id: "America/Denver", displayName: "Mountain Standard Time"},
      {id: "America/Detroit", displayName: "Eastern Standard Time"},
      {id: "America/Dominica", displayName: "Atlantic Standard Time"},
      {id: "America/Edmonton", displayName: "Mountain Standard Time"},
      {id: "America/Eirunepe", displayName: "Acre Time"},
      {id: "America/El_Salvador", displayName: "Central Standard Time"},
      {id: "America/Ensenada", displayName: "Pacific Standard Time"},
      {id: "America/Fort_Nelson", displayName: "Mountain Standard Time"},
      {id: "America/Fort_Wayne", displayName: "Eastern Standard Time"},
      {id: "America/Fortaleza", displayName: "Brasilia Time"},
      {id: "America/Glace_Bay", displayName: "Atlantic Standard Time"},
      {id: "America/Godthab", displayName: "Western Greenland Time"},
      {id: "America/Goose_Bay", displayName: "Atlantic Standard Time"},
      {id: "America/Grand_Turk", displayName: "Eastern Standard Time"},
      {id: "America/Grenada", displayName: "Atlantic Standard Time"},
      {id: "America/Guadeloupe", displayName: "Atlantic Standard Time"},
      {id: "America/Guatemala", displayName: "Central Standard Time"},
      {id: "America/Guayaquil", displayName: "Ecuador Time"},
      {id: "America/Guyana", displayName: "Guyana Time"},
      {id: "America/Halifax", displayName: "Atlantic Standard Time"},
      {id: "America/Havana", displayName: "Cuba Standard Time"},
      {id: "America/Hermosillo", displayName: "Mountain Standard Time"},
      {id: "America/Indiana/Indianapolis", displayName: "Eastern Standard Time"},
      {id: "America/Indiana/Knox", displayName: "Central Standard Time"},
      {id: "America/Indiana/Marengo", displayName: "Eastern Standard Time"},
      {id: "America/Indiana/Petersburg", displayName: "Eastern Standard Time"},
      {id: "America/Indiana/Tell_City", displayName: "Central Standard Time"},
      {id: "America/Indiana/Vevay", displayName: "Eastern Standard Time"},
      {id: "America/Indiana/Vincennes", displayName: "Eastern Standard Time"},
      {id: "America/Indiana/Winamac", displayName: "Eastern Standard Time"},
      {id: "America/Indianapolis", displayName: "Eastern Standard Time"},
      {id: "America/Inuvik", displayName: "Mountain Standard Time"},
      {id: "America/Iqaluit", displayName: "Eastern Standard Time"},
      {id: "America/Jamaica", displayName: "Eastern Standard Time"},
      {id: "America/Jujuy", displayName: "Argentine Time"},
      {id: "America/Juneau", displayName: "Alaska Standard Time"},
      {id: "America/Kentucky/Louisville", displayName: "Eastern Standard Time"},
      {id: "America/Kentucky/Monticello", displayName: "Eastern Standard Time"},
      {id: "America/Knox_IN", displayName: "Central Standard Time"},
      {id: "America/Kralendijk", displayName: "Atlantic Standard Time"},
      {id: "America/La_Paz", displayName: "Bolivia Time"},
      {id: "America/Lima", displayName: "Peru Time"},
      {id: "America/Los_Angeles", displayName: "Pacific Standard Time"},
      {id: "America/Louisville", displayName: "Eastern Standard Time"},
      {id: "America/Lower_Princes", displayName: "Atlantic Standard Time"},
      {id: "America/Maceio", displayName: "Brasilia Time"},
      {id: "America/Managua", displayName: "Central Standard Time"},
      {id: "America/Manaus", displayName: "Amazon Time"},
      {id: "America/Marigot", displayName: "Atlantic Standard Time"},
      {id: "America/Martinique", displayName: "Atlantic Standard Time"},
      {id: "America/Matamoros", displayName: "Central Standard Time"},
      {id: "America/Mazatlan", displayName: "Mountain Standard Time"},
      {id: "America/Mendoza", displayName: "Argentine Time"},
      {id: "America/Menominee", displayName: "Central Standard Time"},
      {id: "America/Merida", displayName: "Central Standard Time"},
      {id: "America/Metlakatla", displayName: "Alaska Standard Time"},
      {id: "America/Mexico_City", displayName: "Central Standard Time"},
      {id: "America/Miquelon", displayName: "Pierre & Miquelon Standard Time"},
      {id: "America/Moncton", displayName: "Atlantic Standard Time"},
      {id: "America/Monterrey", displayName: "Central Standard Time"},
      {id: "America/Montevideo", displayName: "Uruguay Time"},
      {id: "America/Montreal", displayName: "Eastern Standard Time"},
      {id: "America/Montserrat", displayName: "Atlantic Standard Time"},
      {id: "America/Nassau", displayName: "Eastern Standard Time"},
      {id: "America/New_York", displayName: "Eastern Standard Time"},
      {id: "America/Nipigon", displayName: "Eastern Standard Time"},
      {id: "America/Nome", displayName: "Alaska Standard Time"},
      {id: "America/Noronha", displayName: "Fernando de Noronha Time"},
      {id: "America/North_Dakota/Beulah", displayName: "Central Standard Time"},
      {id: "America/North_Dakota/Center", displayName: "Central Standard Time"},
      {id: "America/North_Dakota/New_Salem", displayName: "Central Standard Time"},
      {id: "America/Ojinaga", displayName: "Mountain Standard Time"},
      {id: "America/Panama", displayName: "Eastern Standard Time"},
      {id: "America/Pangnirtung", displayName: "Eastern Standard Time"},
      {id: "America/Paramaribo", displayName: "Suriname Time"},
      {id: "America/Phoenix", displayName: "Mountain Standard Time"},
      {id: "America/Port-au-Prince", displayName: "Eastern Standard Time"},
      {id: "America/Port_of_Spain", displayName: "Atlantic Standard Time"},
      {id: "America/Porto_Acre", displayName: "Acre Time"},
      {id: "America/Porto_Velho", displayName: "Amazon Time"},
      {id: "America/Puerto_Rico", displayName: "Atlantic Standard Time"},
      {id: "America/Punta_Arenas", displayName: "GMT-03:00"},
      {id: "America/Rainy_River", displayName: "Central Standard Time"},
      {id: "America/Rankin_Inlet", displayName: "Central Standard Time"},
      {id: "America/Recife", displayName: "Brasilia Time"},
      {id: "America/Regina", displayName: "Central Standard Time"},
      {id: "America/Resolute", displayName: "Central Standard Time"},
      {id: "America/Rio_Branco", displayName: "Acre Time"},
      {id: "America/Rosario", displayName: "Argentine Time"},
      {id: "America/Santa_Isabel", displayName: "Pacific Standard Time"},
      {id: "America/Santarem", displayName: "Brasilia Time"},
      {id: "America/Santiago", displayName: "Chile Time"},
      {id: "America/Santo_Domingo", displayName: "Atlantic Standard Time"},
      {id: "America/Sao_Paulo", displayName: "Brasilia Time"},
      {id: "America/Scoresbysund", displayName: "Eastern Greenland Time"},
      {id: "America/Shiprock", displayName: "Mountain Standard Time"},
      {id: "America/Sitka", displayName: "Alaska Standard Time"},
      {id: "America/St_Barthelemy", displayName: "Atlantic Standard Time"},
      {id: "America/St_Johns", displayName: "Newfoundland Standard Time"},
      {id: "America/St_Kitts", displayName: "Atlantic Standard Time"},
      {id: "America/St_Lucia", displayName: "Atlantic Standard Time"},
      {id: "America/St_Thomas", displayName: "Atlantic Standard Time"},
      {id: "America/St_Vincent", displayName: "Atlantic Standard Time"},
      {id: "America/Swift_Current", displayName: "Central Standard Time"},
      {id: "America/Tegucigalpa", displayName: "Central Standard Time"},
      {id: "America/Thule", displayName: "Atlantic Standard Time"},
      {id: "America/Thunder_Bay", displayName: "Eastern Standard Time"},
      {id: "America/Tijuana", displayName: "Pacific Standard Time"},
      {id: "America/Toronto", displayName: "Eastern Standard Time"},
      {id: "America/Tortola", displayName: "Atlantic Standard Time"},
      {id: "America/Vancouver", displayName: "Pacific Standard Time"},
      {id: "America/Virgin", displayName: "Atlantic Standard Time"},
      {id: "America/Whitehorse", displayName: "Pacific Standard Time"},
      {id: "America/Winnipeg", displayName: "Central Standard Time"},
      {id: "America/Yakutat", displayName: "Alaska Standard Time"},
      {id: "America/Yellowknife", displayName: "Mountain Standard Time"},
      {id: "Antarctica/Casey", displayName: "Australian Western Standard Time"},
      {id: "Antarctica/Davis", displayName: "Davis Time"},
      {id: "Antarctica/DumontDUrville", displayName: "Dumont-d'Urville Time"},
      {id: "Antarctica/Macquarie", displayName: "Macquarie Island Standard Time"},
      {id: "Antarctica/Mawson", displayName: "Mawson Time"},
      {id: "Antarctica/McMurdo", displayName: "New Zealand Standard Time"},
      {id: "Antarctica/Palmer", displayName: "Chile Time"},
      {id: "Antarctica/Rothera", displayName: "Rothera Time"},
      {id: "Antarctica/South_Pole", displayName: "New Zealand Standard Time"},
      {id: "Antarctica/Syowa", displayName: "Syowa Time"},
      {id: "Antarctica/Troll", displayName: "Coordinated Universal Time"},
      {id: "Antarctica/Vostok", displayName: "Vostok Time"},
      {id: "Arctic/Longyearbyen", displayName: "Central European Time"},
      {id: "Asia/Aden", displayName: "Arabia Standard Time"},
      {id: "Asia/Almaty", displayName: "Alma-Ata Time"},
      {id: "Asia/Amman", displayName: "Eastern European Time"},
      {id: "Asia/Anadyr", displayName: "Anadyr Time"},
      {id: "Asia/Aqtau", displayName: "Aqtau Time"},
      {id: "Asia/Aqtobe", displayName: "Aqtobe Time"},
      {id: "Asia/Ashgabat", displayName: "Turkmenistan Time"},
      {id: "Asia/Ashkhabad", displayName: "Turkmenistan Time"},
      {id: "Asia/Atyrau", displayName: "GMT+05:00"},
      {id: "Asia/Baghdad", displayName: "Arabia Standard Time"},
      {id: "Asia/Bahrain", displayName: "Arabia Standard Time"},
      {id: "Asia/Baku", displayName: "Azerbaijan Time"},
      {id: "Asia/Bangkok", displayName: "Indochina Time"},
      {id: "Asia/Barnaul", displayName: "GMT+07:00"},
      {id: "Asia/Beirut", displayName: "Eastern European Time"},
      {id: "Asia/Bishkek", displayName: "Kirgizstan Time"},
      {id: "Asia/Brunei", displayName: "Brunei Time"},
      {id: "Asia/Calcutta", displayName: "India Standard Time"},
      {id: "Asia/Chita", displayName: "Yakutsk Time"},
      {id: "Asia/Choibalsan", displayName: "Choibalsan Time"},
      {id: "Asia/Chongqing", displayName: "China Standard Time"},
      {id: "Asia/Chungking", displayName: "China Standard Time"},
      {id: "Asia/Colombo", displayName: "India Standard Time"},
      {id: "Asia/Dacca", displayName: "Bangladesh Time"},
      {id: "Asia/Damascus", displayName: "Eastern European Time"},
      {id: "Asia/Dhaka", displayName: "Bangladesh Time"},
      {id: "Asia/Dili", displayName: "Timor-Leste Time"},
      {id: "Asia/Dubai", displayName: "Gulf Standard Time"},
      {id: "Asia/Dushanbe", displayName: "Tajikistan Time"},
      {id: "Asia/Famagusta", displayName: "GMT+02:00"},
      {id: "Asia/Gaza", displayName: "Eastern European Time"},
      {id: "Asia/Harbin", displayName: "China Standard Time"},
      {id: "Asia/Hebron", displayName: "Eastern European Time"},
      {id: "Asia/Ho_Chi_Minh", displayName: "Indochina Time"},
      {id: "Asia/Hong_Kong", displayName: "Hong Kong Time"},
      {id: "Asia/Hovd", displayName: "Hovd Time"},
      {id: "Asia/Irkutsk", displayName: "Irkutsk Time"},
      {id: "Asia/Istanbul", displayName: "Eastern European Time"},
      {id: "Asia/Jakarta", displayName: "West Indonesia Time"},
      {id: "Asia/Jayapura", displayName: "East Indonesia Time"},
      {id: "Asia/Jerusalem", displayName: "Israel Standard Time"},
      {id: "Asia/Kabul", displayName: "Afghanistan Time"},
      {id: "Asia/Kamchatka", displayName: "Petropavlovsk-Kamchatski Time"},
      {id: "Asia/Karachi", displayName: "Pakistan Time"},
      {id: "Asia/Kashgar", displayName: "Xinjiang Standard Time"},
      {id: "Asia/Kathmandu", displayName: "Nepal Time"},
      {id: "Asia/Katmandu", displayName: "Nepal Time"},
      {id: "Asia/Khandyga", displayName: "Yakutsk Time"},
      {id: "Asia/Kolkata", displayName: "India Standard Time"},
      {id: "Asia/Krasnoyarsk", displayName: "Krasnoyarsk Time"},
      {id: "Asia/Kuala_Lumpur", displayName: "Malaysia Time"},
      {id: "Asia/Kuching", displayName: "Malaysia Time"},
      {id: "Asia/Kuwait", displayName: "Arabia Standard Time"},
      {id: "Asia/Macao", displayName: "China Standard Time"},
      {id: "Asia/Macau", displayName: "China Standard Time"},
      {id: "Asia/Magadan", displayName: "Magadan Time"},
      {id: "Asia/Makassar", displayName: "Central Indonesia Time"},
      {id: "Asia/Manila", displayName: "Philippines Time"},
      {id: "Asia/Muscat", displayName: "Gulf Standard Time"},
      {id: "Asia/Nicosia", displayName: "Eastern European Time"},
      {id: "Asia/Novokuznetsk", displayName: "Krasnoyarsk Time"},
      {id: "Asia/Novosibirsk", displayName: "Novosibirsk Time"},
      {id: "Asia/Omsk", displayName: "Omsk Time"},
      {id: "Asia/Oral", displayName: "Oral Time"},
      {id: "Asia/Phnom_Penh", displayName: "Indochina Time"},
      {id: "Asia/Pontianak", displayName: "West Indonesia Time"},
      {id: "Asia/Pyongyang", displayName: "Korea Standard Time"},
      {id: "Asia/Qatar", displayName: "Arabia Standard Time"},
      {id: "Asia/Qyzylorda", displayName: "Qyzylorda Time"},
      {id: "Asia/Rangoon", displayName: "Myanmar Time"},
      {id: "Asia/Riyadh", displayName: "Arabia Standard Time"},
      {id: "Asia/Saigon", displayName: "Indochina Time"},
      {id: "Asia/Sakhalin", displayName: "Sakhalin Time"},
      {id: "Asia/Samarkand", displayName: "Uzbekistan Time"},
      {id: "Asia/Seoul", displayName: "Korea Standard Time"},
      {id: "Asia/Shanghai", displayName: "China Standard Time"},
      {id: "Asia/Singapore", displayName: "Singapore Time"},
      {id: "Asia/Srednekolymsk", displayName: "Srednekolymsk Time"},
      {id: "Asia/Taipei", displayName: "China Standard Time"},
      {id: "Asia/Tashkent", displayName: "Uzbekistan Time"},
      {id: "Asia/Tbilisi", displayName: "Georgia Time"},
      {id: "Asia/Tehran", displayName: "Iran Standard Time"},
      {id: "Asia/Tel_Aviv", displayName: "Israel Standard Time"},
      {id: "Asia/Thimbu", displayName: "Bhutan Time"},
      {id: "Asia/Thimphu", displayName: "Bhutan Time"},
      {id: "Asia/Tokyo", displayName: "Japan Standard Time"},
      {id: "Asia/Tomsk", displayName: "GMT+07:00"},
      {id: "Asia/Ujung_Pandang", displayName: "Central Indonesia Time"},
      {id: "Asia/Ulaanbaatar", displayName: "Ulaanbaatar Time"},
      {id: "Asia/Ulan_Bator", displayName: "Ulaanbaatar Time"},
      {id: "Asia/Urumqi", displayName: "Xinjiang Standard Time"},
      {id: "Asia/Ust-Nera", displayName: "Ust-Nera Time"},
      {id: "Asia/Vientiane", displayName: "Indochina Time"},
      {id: "Asia/Vladivostok", displayName: "Vladivostok Time"},
      {id: "Asia/Yakutsk", displayName: "Yakutsk Time"},
      {id: "Asia/Yangon", displayName: "Myanmar Time"},
      {id: "Asia/Yekaterinburg", displayName: "Yekaterinburg Time"},
      {id: "Asia/Yerevan", displayName: "Armenia Time"},
      {id: "Atlantic/Azores", displayName: "Azores Time"},
      {id: "Atlantic/Bermuda", displayName: "Atlantic Standard Time"},
      {id: "Atlantic/Canary", displayName: "Western European Time"},
      {id: "Atlantic/Cape_Verde", displayName: "Cape Verde Time"},
      {id: "Atlantic/Faeroe", displayName: "Western European Time"},
      {id: "Atlantic/Faroe", displayName: "Western European Time"},
      {id: "Atlantic/Jan_Mayen", displayName: "Central European Time"},
      {id: "Atlantic/Madeira", displayName: "Western European Time"},
      {id: "Atlantic/Reykjavik", displayName: "Greenwich Mean Time"},
      {id: "Atlantic/South_Georgia", displayName: "South Georgia Standard Time"},
      {id: "Atlantic/St_Helena", displayName: "Greenwich Mean Time"},
      {id: "Atlantic/Stanley", displayName: "Falkland Is. Time"},
      {
        id: "Australia/ACT",
        displayName: "Australian Eastern Standard Time (New South Wales)"
      },
      {
        id: "Australia/Adelaide",
        displayName: "Australian Central Standard Time (South Australia)"
      },
      {
        id: "Australia/Brisbane",
        displayName: "Australian Eastern Standard Time (Queensland)"
      },
      {
        id: "Australia/Broken_Hill",
        displayName: "Australian Central Standard Time (South Australia/New South Wales)"
      },
      {
        id: "Australia/Canberra",
        displayName: "Australian Eastern Standard Time (New South Wales)"
      },
      {
        id: "Australia/Currie",
        displayName: "Australian Eastern Standard Time (New South Wales)"
      },
      {
        id: "Australia/Darwin",
        displayName: "Australian Central Standard Time (Northern Territory)"
      },
      {
        id: "Australia/Eucla",
        displayName: "Australian Central Western Standard Time"
      },
      {
        id: "Australia/Hobart",
        displayName: "Australian Eastern Standard Time (Tasmania)"
      },
      {id: "Australia/LHI", displayName: "Lord Howe Standard Time"},
      {
        id: "Australia/Lindeman",
        displayName: "Australian Eastern Standard Time (Queensland)"
      },
      {id: "Australia/Lord_Howe", displayName: "Lord Howe Standard Time"},
      {
        id: "Australia/Melbourne",
        displayName: "Australian Eastern Standard Time (Victoria)"
      },
      {
        id: "Australia/NSW",
        displayName: "Australian Eastern Standard Time (New South Wales)"
      },
      {
        id: "Australia/North",
        displayName: "Australian Central Standard Time (Northern Territory)"
      },
      {id: "Australia/Perth", displayName: "Australian Western Standard Time"},
      {
        id: "Australia/Queensland",
        displayName: "Australian Eastern Standard Time (Queensland)"
      },
      {
        id: "Australia/South",
        displayName: "Australian Central Standard Time (South Australia)"
      },
      {
        id: "Australia/Sydney",
        displayName: "Australian Eastern Standard Time (New South Wales)"
      },
      {
        id: "Australia/Tasmania",
        displayName: "Australian Eastern Standard Time (Tasmania)"
      },
      {
        id: "Australia/Victoria",
        displayName: "Australian Eastern Standard Time (Victoria)"
      },
      {id: "Australia/West", displayName: "Australian Western Standard Time"},
      {
        id: "Australia/Yancowinna",
        displayName: "Australian Central Standard Time (South Australia/New South Wales)"
      },
      {id: "Brazil/Acre", displayName: "Acre Time"},
      {id: "Brazil/DeNoronha", displayName: "Fernando de Noronha Time"},
      {id: "Brazil/East", displayName: "Brasilia Time"},
      {id: "Brazil/West", displayName: "Amazon Time"},
      {id: "CET", displayName: "Central European Time"},
      {id: "CST6CDT", displayName: "Central Standard Time"},
      {id: "Canada/Atlantic", displayName: "Atlantic Standard Time"},
      {id: "Canada/Central", displayName: "Central Standard Time"},
      {id: "Canada/Eastern", displayName: "Eastern Standard Time"},
      {id: "Canada/Mountain", displayName: "Mountain Standard Time"},
      {id: "Canada/Newfoundland", displayName: "Newfoundland Standard Time"},
      {id: "Canada/Pacific", displayName: "Pacific Standard Time"},
      {id: "Canada/Saskatchewan", displayName: "Central Standard Time"},
      {id: "Canada/Yukon", displayName: "Pacific Standard Time"},
      {id: "Chile/Continental", displayName: "Chile Time"},
      {id: "Chile/EasterIsland", displayName: "Easter Is. Time"},
      {id: "Cuba", displayName: "Cuba Standard Time"},
      {id: "EET", displayName: "Eastern European Time"},
      {id: "EST5EDT", displayName: "Eastern Standard Time"},
      {id: "Egypt", displayName: "Eastern European Time"},
      {id: "Eire", displayName: "Greenwich Mean Time"},
      {id: "Etc/GMT", displayName: "Greenwich Mean Time"},
      {id: "Etc/GMT+0", displayName: "Greenwich Mean Time"},
      {id: "Etc/GMT+1", displayName: "GMT-01:00"},
      {id: "Etc/GMT+10", displayName: "GMT-10:00"},
      {id: "Etc/GMT+11", displayName: "GMT-11:00"},
      {id: "Etc/GMT+12", displayName: "GMT-12:00"},
      {id: "Etc/GMT+2", displayName: "GMT-02:00"},
      {id: "Etc/GMT+3", displayName: "GMT-03:00"},
      {id: "Etc/GMT+4", displayName: "GMT-04:00"},
      {id: "Etc/GMT+5", displayName: "GMT-05:00"},
      {id: "Etc/GMT+6", displayName: "GMT-06:00"},
      {id: "Etc/GMT+7", displayName: "GMT-07:00"},
      {id: "Etc/GMT+8", displayName: "GMT-08:00"},
      {id: "Etc/GMT+9", displayName: "GMT-09:00"},
      {id: "Etc/GMT-0", displayName: "Greenwich Mean Time"},
      {id: "Etc/GMT-1", displayName: "GMT+01:00"},
      {id: "Etc/GMT-10", displayName: "GMT+10:00"},
      {id: "Etc/GMT-11", displayName: "GMT+11:00"},
      {id: "Etc/GMT-12", displayName: "GMT+12:00"},
      {id: "Etc/GMT-13", displayName: "GMT+13:00"},
      {id: "Etc/GMT-14", displayName: "GMT+14:00"},
      {id: "Etc/GMT-2", displayName: "GMT+02:00"},
      {id: "Etc/GMT-3", displayName: "GMT+03:00"},
      {id: "Etc/GMT-4", displayName: "GMT+04:00"},
      {id: "Etc/GMT-5", displayName: "GMT+05:00"},
      {id: "Etc/GMT-6", displayName: "GMT+06:00"},
      {id: "Etc/GMT-7", displayName: "GMT+07:00"},
      {id: "Etc/GMT-8", displayName: "GMT+08:00"},
      {id: "Etc/GMT-9", displayName: "GMT+09:00"},
      {id: "Etc/GMT0", displayName: "Greenwich Mean Time"},
      {id: "Etc/Greenwich", displayName: "Greenwich Mean Time"},
      {id: "Etc/UCT", displayName: "Coordinated Universal Time"},
      {id: "Etc/UTC", displayName: "Coordinated Universal Time"},
      {id: "Etc/Universal", displayName: "Coordinated Universal Time"},
      {id: "Etc/Zulu", displayName: "Coordinated Universal Time"},
      {id: "Europe/Amsterdam", displayName: "Central European Time"},
      {id: "Europe/Andorra", displayName: "Central European Time"},
      {id: "Europe/Astrakhan", displayName: "GMT+04:00"},
      {id: "Europe/Athens", displayName: "Eastern European Time"},
      {id: "Europe/Belfast", displayName: "Greenwich Mean Time"},
      {id: "Europe/Belgrade", displayName: "Central European Time"},
      {id: "Europe/Berlin", displayName: "Central European Time"},
      {id: "Europe/Bratislava", displayName: "Central European Time"},
      {id: "Europe/Brussels", displayName: "Central European Time"},
      {id: "Europe/Bucharest", displayName: "Eastern European Time"},
      {id: "Europe/Budapest", displayName: "Central European Time"},
      {id: "Europe/Busingen", displayName: "Central European Time"},
      {id: "Europe/Chisinau", displayName: "Eastern European Time"},
      {id: "Europe/Copenhagen", displayName: "Central European Time"},
      {id: "Europe/Dublin", displayName: "Greenwich Mean Time"},
      {id: "Europe/Gibraltar", displayName: "Central European Time"},
      {id: "Europe/Guernsey", displayName: "Greenwich Mean Time"},
      {id: "Europe/Helsinki", displayName: "Eastern European Time"},
      {id: "Europe/Isle_of_Man", displayName: "Greenwich Mean Time"},
      {id: "Europe/Istanbul", displayName: "Eastern European Time"},
      {id: "Europe/Jersey", displayName: "Greenwich Mean Time"},
      {id: "Europe/Kaliningrad", displayName: "Eastern European Time"},
      {id: "Europe/Kiev", displayName: "Eastern European Time"},
      {id: "Europe/Kirov", displayName: "GMT+03:00"},
      {id: "Europe/Lisbon", displayName: "Western European Time"},
      {id: "Europe/Ljubljana", displayName: "Central European Time"},
      {id: "Europe/London", displayName: "Greenwich Mean Time"},
      {id: "Europe/Luxembourg", displayName: "Central European Time"},
      {id: "Europe/Madrid", displayName: "Central European Time"},
      {id: "Europe/Malta", displayName: "Central European Time"},
      {id: "Europe/Mariehamn", displayName: "Eastern European Time"},
      {id: "Europe/Minsk", displayName: "Moscow Standard Time"},
      {id: "Europe/Monaco", displayName: "Central European Time"},
      {id: "Europe/Moscow", displayName: "Moscow Standard Time"},
      {id: "Europe/Nicosia", displayName: "Eastern European Time"},
      {id: "Europe/Oslo", displayName: "Central European Time"},
      {id: "Europe/Paris", displayName: "Central European Time"},
      {id: "Europe/Podgorica", displayName: "Central European Time"},
      {id: "Europe/Prague", displayName: "Central European Time"},
      {id: "Europe/Riga", displayName: "Eastern European Time"},
      {id: "Europe/Rome", displayName: "Central European Time"},
      {id: "Europe/Samara", displayName: "Samara Time"},
      {id: "Europe/San_Marino", displayName: "Central European Time"},
      {id: "Europe/Sarajevo", displayName: "Central European Time"},
      {id: "Europe/Saratov", displayName: "GMT+04:00"},
      {id: "Europe/Simferopol", displayName: "Moscow Standard Time"},
      {id: "Europe/Skopje", displayName: "Central European Time"},
      {id: "Europe/Sofia", displayName: "Eastern European Time"},
      {id: "Europe/Stockholm", displayName: "Central European Time"},
      {id: "Europe/Tallinn", displayName: "Eastern European Time"},
      {id: "Europe/Tirane", displayName: "Central European Time"},
      {id: "Europe/Tiraspol", displayName: "Eastern European Time"},
      {id: "Europe/Ulyanovsk", displayName: "GMT+04:00"},
      {id: "Europe/Uzhgorod", displayName: "Eastern European Time"},
      {id: "Europe/Vaduz", displayName: "Central European Time"},
      {id: "Europe/Vatican", displayName: "Central European Time"},
      {id: "Europe/Vienna", displayName: "Central European Time"},
      {id: "Europe/Vilnius", displayName: "Eastern European Time"},
      {id: "Europe/Volgograd", displayName: "Moscow Standard Time"},
      {id: "Europe/Warsaw", displayName: "Central European Time"},
      {id: "Europe/Zagreb", displayName: "Central European Time"},
      {id: "Europe/Zaporozhye", displayName: "Eastern European Time"},
      {id: "Europe/Zurich", displayName: "Central European Time"},
      {id: "GB", displayName: "Greenwich Mean Time"},
      {id: "GB-Eire", displayName: "Greenwich Mean Time"},
      {id: "GMT", displayName: "Greenwich Mean Time"},
      {id: "GMT0", displayName: "Greenwich Mean Time"},
      {id: "Greenwich", displayName: "Greenwich Mean Time"},
      {id: "Hongkong", displayName: "Hong Kong Time"},
      {id: "Iceland", displayName: "Greenwich Mean Time"},
      {id: "Indian/Antananarivo", displayName: "Eastern African Time"},
      {id: "Indian/Chagos", displayName: "Indian Ocean Territory Time"},
      {id: "Indian/Christmas", displayName: "Christmas Island Time"},
      {id: "Indian/Cocos", displayName: "Cocos Islands Time"},
      {id: "Indian/Comoro", displayName: "Eastern African Time"},
      {id: "Indian/Kerguelen", displayName: "French Southern & Antarctic Lands Time"},
      {id: "Indian/Mahe", displayName: "Seychelles Time"},
      {id: "Indian/Maldives", displayName: "Maldives Time"},
      {id: "Indian/Mauritius", displayName: "Mauritius Time"},
      {id: "Indian/Mayotte", displayName: "Eastern African Time"},
      {id: "Indian/Reunion", displayName: "Reunion Time"},
      {id: "Iran", displayName: "Iran Standard Time"},
      {id: "Israel", displayName: "Israel Standard Time"},
      {id: "Jamaica", displayName: "Eastern Standard Time"},
      {id: "Japan", displayName: "Japan Standard Time"},
      {id: "Kwajalein", displayName: "Marshall Islands Time"},
      {id: "Libya", displayName: "Eastern European Time"},
      {id: "MET", displayName: "Middle Europe Time"},
      {id: "MST7MDT", displayName: "Mountain Standard Time"},
      {id: "Mexico/BajaNorte", displayName: "Pacific Standard Time"},
      {id: "Mexico/BajaSur", displayName: "Mountain Standard Time"},
      {id: "Mexico/General", displayName: "Central Standard Time"},
      {id: "NZ", displayName: "New Zealand Standard Time"},
      {id: "NZ-CHAT", displayName: "Chatham Standard Time"},
      {id: "Navajo", displayName: "Mountain Standard Time"},
      {id: "PRC", displayName: "China Standard Time"},
      {id: "PST8PDT", displayName: "Pacific Standard Time"},
      {id: "Pacific/Apia", displayName: "West Samoa Standard Time"},
      {id: "Pacific/Auckland", displayName: "New Zealand Standard Time"},
      {id: "Pacific/Bougainville", displayName: "Bougainville Standard Time"},
      {id: "Pacific/Chatham", displayName: "Chatham Standard Time"},
      {id: "Pacific/Chuuk", displayName: "Chuuk Time"},
      {id: "Pacific/Easter", displayName: "Easter Is. Time"},
      {id: "Pacific/Efate", displayName: "Vanuatu Time"},
      {id: "Pacific/Enderbury", displayName: "Phoenix Is. Time"},
      {id: "Pacific/Fakaofo", displayName: "Tokelau Time"},
      {id: "Pacific/Fiji", displayName: "Fiji Time"},
      {id: "Pacific/Funafuti", displayName: "Tuvalu Time"},
      {id: "Pacific/Galapagos", displayName: "Galapagos Time"},
      {id: "Pacific/Gambier", displayName: "Gambier Time"},
      {id: "Pacific/Guadalcanal", displayName: "Solomon Is. Time"},
      {id: "Pacific/Guam", displayName: "Chamorro Standard Time"},
      {id: "Pacific/Honolulu", displayName: "Hawaii Standard Time"},
      {id: "Pacific/Johnston", displayName: "Hawaii Standard Time"},
      {id: "Pacific/Kiritimati", displayName: "Line Is. Time"},
      {id: "Pacific/Kosrae", displayName: "Kosrae Time"},
      {id: "Pacific/Kwajalein", displayName: "Marshall Islands Time"},
      {id: "Pacific/Majuro", displayName: "Marshall Islands Time"},
      {id: "Pacific/Marquesas", displayName: "Marquesas Time"},
      {id: "Pacific/Midway", displayName: "Samoa Standard Time"},
      {id: "Pacific/Nauru", displayName: "Nauru Time"},
      {id: "Pacific/Niue", displayName: "Niue Time"},
      {id: "Pacific/Norfolk", displayName: "Norfolk Time"},
      {id: "Pacific/Noumea", displayName: "New Caledonia Time"},
      {id: "Pacific/Pago_Pago", displayName: "Samoa Standard Time"},
      {id: "Pacific/Palau", displayName: "Palau Time"},
      {id: "Pacific/Pitcairn", displayName: "Pitcairn Standard Time"},
      {id: "Pacific/Pohnpei", displayName: "Pohnpei Time"},
      {id: "Pacific/Ponape", displayName: "Pohnpei Time"},
      {id: "Pacific/Port_Moresby", displayName: "Papua New Guinea Time"},
      {id: "Pacific/Rarotonga", displayName: "Cook Is. Time"},
      {id: "Pacific/Saipan", displayName: "Chamorro Standard Time"},
      {id: "Pacific/Samoa", displayName: "Samoa Standard Time"},
      {id: "Pacific/Tahiti", displayName: "Tahiti Time"},
      {id: "Pacific/Tarawa", displayName: "Gilbert Is. Time"},
      {id: "Pacific/Tongatapu", displayName: "Tonga Time"},
      {id: "Pacific/Truk", displayName: "Chuuk Time"},
      {id: "Pacific/Wake", displayName: "Wake Time"},
      {id: "Pacific/Wallis", displayName: "Wallis & Futuna Time"},
      {id: "Pacific/Yap", displayName: "Chuuk Time"},
      {id: "Poland", displayName: "Central European Time"},
      {id: "Portugal", displayName: "Western European Time"},
      {id: "ROK", displayName: "Korea Standard Time"},
      {id: "Singapore", displayName: "Singapore Time"},
      {id: "SystemV/AST4", displayName: "Atlantic Standard Time"},
      {id: "SystemV/AST4ADT", displayName: "Atlantic Standard Time"},
      {id: "SystemV/CST6", displayName: "Central Standard Time"},
      {id: "SystemV/CST6CDT", displayName: "Central Standard Time"},
      {id: "SystemV/EST5", displayName: "Eastern Standard Time"},
      {id: "SystemV/EST5EDT", displayName: "Eastern Standard Time"},
      {id: "SystemV/HST10", displayName: "Hawaii Standard Time"},
      {id: "SystemV/MST7", displayName: "Mountain Standard Time"},
      {id: "SystemV/MST7MDT", displayName: "Mountain Standard Time"},
      {id: "SystemV/PST8", displayName: "Pacific Standard Time"},
      {id: "SystemV/PST8PDT", displayName: "Pacific Standard Time"},
      {id: "SystemV/YST9", displayName: "Alaska Standard Time"},
      {id: "SystemV/YST9YDT", displayName: "Alaska Standard Time"},
      {id: "Turkey", displayName: "Eastern European Time"},
      {id: "UCT", displayName: "Coordinated Universal Time"},
      {id: "US/Alaska", displayName: "Alaska Standard Time"},
      {id: "US/Aleutian", displayName: "Hawaii Standard Time"},
      {id: "US/Arizona", displayName: "Mountain Standard Time"},
      {id: "US/Central", displayName: "Central Standard Time"},
      {id: "US/East-Indiana", displayName: "Eastern Standard Time"},
      {id: "US/Eastern", displayName: "Eastern Standard Time"},
      {id: "US/Hawaii", displayName: "Hawaii Standard Time"},
      {id: "US/Indiana-Starke", displayName: "Central Standard Time"},
      {id: "US/Michigan", displayName: "Eastern Standard Time"},
      {id: "US/Mountain", displayName: "Mountain Standard Time"},
      {id: "US/Pacific", displayName: "Pacific Standard Time"},
      {id: "US/Pacific-New", displayName: "Pacific Standard Time"},
      {id: "US/Samoa", displayName: "Samoa Standard Time"},
      {id: "UTC", displayName: "Coordinated Universal Time"},
      {id: "Universal", displayName: "Coordinated Universal Time"},
      {id: "W-SU", displayName: "Moscow Standard Time"},
      {id: "WET", displayName: "Western European Time"},
      {id: "Zulu", displayName: "Coordinated Universal Time"}]
}
